import { useState, useEffect } from "react";
import { fetchUserData } from "../api";
import type { UserData } from "../types";

export const useUserData = (token: string | null) => {
  const [userData, setUserData] = useState<UserData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const data = await fetchUserData(token);
        setUserData(data);
      } catch (err) {
        console.error("Erro ao buscar dados do usuário:", err);
      } finally {
        setLoading(false);
      }
    };

    fetch();
  }, [token]);

  return { userData, loading };
};
